<template>
  <swiper
    :navigation="{
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }"
    :pagination="{
      bulletActiveClass: 'swiper-pagination-bullet-active',
      clickable: true
    }"
    :loop="true"
    :autoplay="{
      delay: 3000
    }"
    :modules="modules"
    class="mySwiper"
  >
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <swiper-slide>
      <img src="../assets/img/1.jpg" loading="lazy">
    </swiper-slide>
    <!--<swiper-slide>-->
    <!--  <img src="../assets/img/2.jpg" alt="lg backlight for tv" loading="lazy">-->
    <!--</swiper-slide>-->
    <!--<swiper-slide>-->
    <!--  <img src="../assets/img/3.jpg" alt="smd led chip" loading="lazy">-->
    <!--</swiper-slide>-->
  </swiper>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Pagination, Autoplay } from 'swiper'

const modules = [Navigation, Pagination, Autoplay ]
</script>

<style lang="stylus" scoped>
.swiper
  min-width 1280px
  max-width 1920px
  min-height 500px
  max-height 850px
  position relative
  &:hover .swiper-button-next
    display flex
  &:hover .swiper-button-prev
    display flex
  .swiper-button-prev,
  .swiper-button-next
    display none
    width 60px
    height 60px
    z-index 2
    position absolute
    top 50%
    color #FFF
    opacity .5
    background rgba(0,0,0,0.3)
    font-size 15px
    transform translateY(-50%)
    transition all .3s ease-in-out
    &:after
      font-size 25px
    &:hover
      opacity 1
  .swiper-button-prev
    left 50px
  .swiper-button-next
    right 50px
  .swiper-slide
    text-align center
    font-size 18px
    background #fff
    display flex
    justify-content center
    align-items center
    &>img
      display block
      width 100%
      height 100%
      object-fit 100%
:deep(.swiper-pagination-bullet-active)
  background #1e8bac

:deep(.swiper-pagination)
  bottom 16px
</style>
